import { useDispatch, useSelector } from 'react-redux'
import {
    FormWrap,
    FormHeader,
    FormNav,
    NavItem,
    NavLink,
    UserIcon,
    Overlay,
    GoogleIcon,
    FacebookIcon,
    FormFooter,
    FormFooterText,
    Social,
    SocialLogin,
    FormBody,
    FormGroup,
    TextUnderline,
    FormSubmit,
} from './authFormElements'
import { openFormLogin, openFormRegister, closeForm } from '../../store/reducer/authFormSlice'
import { loadUser, register, login } from '../../store/reducer/userSlice'
import { Form, Formik, FastField } from 'formik'
import InputField from '../../customFields/InputField'
import * as Yup from 'yup'
import { unwrapResult } from '@reduxjs/toolkit'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { useState } from 'react'

const AuthForm = () => {
    const { isOpen, isLogin } = useSelector(state => state.authForm)
    const dispatch = useDispatch()

    const [open, setOpen] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }

        setOpen(false);
    };

    const Alert = props => {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
      }

    const showLoginForm = e => {
        e.preventDefault()
        document.getElementById('auth-form')?.reset()
        dispatch(openFormLogin());
    }

    const showRegisterForm = e => {
        e.preventDefault()
        document.getElementById('auth-form')?.reset()
        dispatch(openFormRegister());
    }

    const closeAuthForm = e => {
        e.preventDefault()
        document.getElementById('auth-form')?.reset()
        dispatch(closeForm());
    }

    const redirectToGoogleSSO = async e => {
        let timer
        e.preventDefault()
        const googleLoginUrl = `${process.env.REACT_APP_BASE_URL_SERVER}/api/auth/google`;
        const newWindow = window.open(
            googleLoginUrl,
            "_blank",
            "width=500,height=600"
          );

          if (newWindow) {
            timer = setInterval(async() => {
              if (newWindow.closed) {
                (async () => await dispatch(loadUser()))()
                document.getElementById('auth-form')?.reset()
                dispatch(closeForm())
                if (timer) clearInterval(timer);
              }
            }, 500);
          }
    }

    const redirectToFacebookSSO = async e => {
        let timer
        e.preventDefault()
        const googleLoginUrl = `${process.env.REACT_APP_BASE_URL_SERVER}/api/auth/facebook`;
        const newWindow = window.open(
            googleLoginUrl,
            "_blank",
            "width=500,height=600"
          );

          if (newWindow) {
            timer = setInterval(async() => {
              if (newWindow.closed) {
                (async () => await dispatch(loadUser()))()
                document.getElementById('auth-form')?.reset()
                dispatch(closeForm())
                if (timer) clearInterval(timer);
              }
            }, 500);
          }
    }

    const initialValues = {
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
    }

    const validationSchema = Yup.object().shape({
        username: !isLogin && Yup.string().required('Vui lòng nhập tên của bạn'),
        email: Yup.string().required('Vui lòng nhập email').email('Email không đúng định dạng'),
        password: Yup.string().required('Vui lòng nhập mật khẩu').min(6, 'Mật khẩu phải chứa ít nhất 6 kí tự'),
        confirmPassword: !isLogin && Yup.string().required('Vui lòng xác nhận mật khẩu').oneOf([Yup.ref('password'), null], 'Mật khẩu xác nhận không đúng')
    })
    
    const handleSubmit = async (values, {resetForm, setFieldError}) => {
        try {
            const actionResult = isLogin ? await dispatch(login(values)) : await dispatch(register(values))
            unwrapResult(actionResult)
            resetForm()
            isLogin ? dispatch(closeForm()) : dispatch(openFormLogin())
            !isLogin && setOpen(true)
        } catch (error) {
            console.log(error)
            isLogin ? setFieldError('password', 'Sai email hoặc mật khẩu'):setFieldError('email', 'Email đã được sử dụng')
        }
    }

    const formBody = <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit = {handleSubmit}
    >
        {formikProps => {
            return isLogin ? (
                <Form id="auth-form" method="POST">
                    <FormGroup>
                        <FastField 
                            name="email"
                            component={InputField}

                            type="text"
                            placeholder="Email đăng nhập"
                        />
                    </FormGroup>
                    <FormGroup>
                        <FastField 
                            name="password"
                            component={InputField}

                            type="password"
                            placeholder="Mật khẩu"
                        />

                    </FormGroup>
                    <FormGroup className="flex-between mb-col">
                        <TextUnderline to='/'>Quên mật khẩu?</TextUnderline>
                        <FormSubmit type="submit">Đăng nhập</FormSubmit>
                    </FormGroup>
                </Form>
            ):(
                <Form method="POST" id="auth-form">
                    <FormGroup>
                        <FastField 
                            name="username"
                            component={InputField}

                            type="text"
                            placeholder="Tên của bạn"
                        />
                    </FormGroup>
                    <FormGroup>
                        <FastField 
                            name="email"
                            component={InputField}

                            type="text"
                            placeholder="Email đăng nhập"
                        />
                    </FormGroup>
                    <FormGroup>
                        <FastField 
                            name="password"
                            component={InputField}

                            type="password"
                            placeholder="Mật khẩu"
                        />
                    </FormGroup>
                    <FormGroup>
                        <FastField 
                            name="confirmPassword"
                            component={InputField}

                            type="password"
                            placeholder="Xác nhận mật khẩu"
                        />
                    </FormGroup>
                    <FormGroup>
                        <TextUnderline className='wrap' to='/'>Khi bấm "Đăng ký" đồng thời bạn đã đồng ý với điều khoản của toà soạn</TextUnderline>
                    </FormGroup>
                    <FormGroup className="flex-between">
                        <FormSubmit style={{marginLeft: 'auto'}} type="submit">Đăng ký</FormSubmit>
                    </FormGroup>
                </Form>
            )
        }}
    </Formik>

    return (
        <>
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    Đăng ký thành công, mời bạn vào gmail để kích hoạt tài khoản
                </Alert>
            </Snackbar>
            <Overlay onClick={closeAuthForm} open={isOpen}/>
            <FormWrap open={isOpen}>
                <FormHeader>
                    <FormNav>
                        <NavItem>
                            <NavLink onClick={showLoginForm} className={isLogin && 'active'} to='/'><UserIcon /> Đăng nhập</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink onClick={showRegisterForm} className={!isLogin && 'active'} to='/'><UserIcon /> Đăng ký</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink onClick={closeAuthForm} to='/'>Đóng lại x</NavLink>
                        </NavItem>
                    </FormNav>
                </FormHeader>
                <FormBody>
                    {formBody}
                </FormBody>
                <FormFooter>
                    <FormFooterText>Hoặc {isLogin ? 'đăng nhập':'Đăng ký'} bằng:</FormFooterText>
                    <Social>
                        <SocialLogin onClick={redirectToGoogleSSO} to="/"><GoogleIcon /></SocialLogin>
                        <SocialLogin onClick={redirectToFacebookSSO} to='/'><FacebookIcon /></SocialLogin>
                    </Social>
                </FormFooter>
            </FormWrap>
        </>
    )
}

export default AuthForm
